<template lang="pug">
div(ref="contenedor")
	div(v-if="galeria")
		mini-item(v-for="(item, i) in galeria.items", :key="item.ItemID", :item="item", @selecciona="selecciona($event)", :ancho="anchoEfectivo", :margen="margen")
		div.text-center.text-danger(v-if="galeria.items.length === 0")
			h1
				span.fa.fa-exclamation
				br
				| No hay elementos en esta galería
		a(style="display:none;", ref="download", target="_blank", :href="'/src/modulos/galerias/php/api/download-galeria.php?GaleriaID=' + galeria.GaleriaID")
	visor-item(v-if="item", @cerrar="item = null", :item-id.sync="item", :listado="listado")
	input(type="file", style="display:none;", multiple="true", accept=".mp4,.jpg,.png", ref="uploader")
	modal-galeria(v-if="editarGaleria", @cerrar="editarGaleria = null", :id-galeria="editarGaleria")
</template>

<script>
import VisorItem from '../visor-item/visor-item'
import ModalGaleria from '../listado-galerias/modal-galeria'
import MiniItem from '../visor-item/mini-item'
import API from '../../api'
import { mapGetters } from 'vuex'
export default {
	props: ['listadoItems'],
	components: {
		'mini-item': MiniItem,
		'visor-item': VisorItem,
		'modal-galeria': ModalGaleria
	},
	data () {
		return {
			idGaleria: null,
			imagenes: [],
			item: null,
			editarGaleria: null,
			anchoEfectivo: 200,
			margen: 2
		}
	},
	created () {
		this.getGaleria(this.$route.params.id)

		const menu2 = {
			id: 'nuevoItem',
			nombre: 'Subir ficheros',
			icono: 'fa fa-upload',
			callback: (e) => {
				this.$refs.uploader.click()
			}
		}

		const download = {
			id: 'descargaGaleria',
			nombre: 'Descargar galería',
			icono: 'fa fa-download',
			callback: (e) => {
				this.$refs.download.click()
			}
		}

		this.$store.commit('top/addMenu', menu2)
		this.$store.commit('top/addMenu', download)
	},
	mounted () {
		this.$refs.uploader.addEventListener('change', () => {
			const ficheros = this.$refs.uploader.files
			for (let i = 0; i < ficheros.length; i++) {
				this.$store.commit('galerias/ADD_COLA', {
					GaleriaID: this.galeria.GaleriaID,
					fichero: ficheros[i]
				})
			}
		})
	},
	beforeDestroy () {
		this.$store.commit('top/delMenu', 'nuevoItem')
		this.$store.commit('top/delMenu', 'editarGaleria')
		this.$store.commit('top/delMenu', 'descargaGaleria')
	},
	watch: {
		idGaleria (newVal, oldVal) {
			if (newVal !== this.idGaleria) {
				this.getGaleria(newVal)
			}
		}
	},
	computed: {
		...mapGetters({
			galeria: 'galerias/galeria'
		}),
		listado () {
			return this.galeria.items.map(i => i.ItemID)
		}
	},
	methods: {
		calcular () {
			const cont = this.$refs.contenedor
			const ancho = cont.clientWidth
			const anchoDeseado = 250
			const anchoFinal = anchoDeseado + (this.margen * 2)
			const caben = Math.round(ancho / anchoFinal)
			this.anchoEfectivo = Math.floor(ancho / caben) - (this.margen * 2) - 2
			console.log('Ancho: ' + ancho + ', efectivo: ' + this.anchoEfectivo)
		},
		getGaleria (idGaleria) {
			this.$store.commit('galerias/SET_GALERIA', null)
			API.getGaleria(idGaleria)
				.then(res => {
					this.calcular()
					res.data.galeria.FechaGaleria = new Date(res.data.galeria.FechaGaleriaUnix * 1000)

					this.$store.commit('galerias/SET_GALERIA', res.data.galeria)

					if (res.data.galeria.Escritura) {
						const menu = {
							id: 'editarGaleria',
							nombre: 'Editar galería',
							icono: 'fa fa-edit',
							callback: (e) => {
								this.editarGaleria = this.$route.params.id
							}
						}

						this.$store.commit('top/addMenu', menu)
					}
				})
				.catch(e => {
					this.$store.commit('toast/danger', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		},
		selecciona (item) {
			this.item = item.ItemID + 0
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/galerias/vue/componentes/visor-galerias/visor-galeria.vue